import styled from '@emotion/styled';
import { Header, ManagePanelIcon } from '../../Header/styled';

export const InstallPrompt = styled.div`
  background-color: #8e4bdf;

  ${Header} {
    color: white;

    ${ManagePanelIcon} {
      > svg {
        color: #fff;
      }
    }
  }
`;

export const InstallPromptTitle = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 20px;
`;

export const PromptText = styled.div`
  display: flex;
  font-size: 12px;
  line-height: 30px;
  color: white;
`;

export const PromptBigText = styled.div`
  display: flex;
  font-size: 14px;
  line-height: 30px;
  color: white;
`;

export const InstallInstruction = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InstuctionLine = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 8px;
`;

export const InstructionText = styled.span`
  font-weight: 600;
`;

export const InstructionImage = styled.img`
  width: 100%;
  margin-top: 20px;
  margin-right: auto;
  margin-left: auto;
`;
